export default __webpack_public_path__ + "locales/ro/Common.json?hash=59dfbeed67755235c464ee5adae0b5fc";